import React from 'react';
/**
 * @param  {} {label
 * @param  {} labelColor
 * @param  {} value}
 */
const DokanSmallCard = ({ label, labelColor, value }) => (
    <div className="x-25px py-35px rounded-md border border-smallCard-border bg-smallCard-bg flex-1">
        <div className="flex flex-col items-center">
            <p className="text-md font-bold text-dark">{value}</p>
            <p className={`text-sm mt-10px font-light ${labelColor || 'text-secondary'}`}>
                {label}
            </p>
        </div>
    </div>
);

export default DokanSmallCard;
